/* RESPONSIBLE TEAM: team-phone */
import Fragment from 'ember-data-model-fragments/fragment';
import { attr, type SyncHasMany } from '@ember-data/model';
import { buildValidations, validator } from 'ember-cp-validations';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import { type Block } from 'embercom/models/common/blocks/block';

// Backend protocol identifier; not user-facing copy.
// eslint-disable-next-line @intercom/intercom/no-bare-strings
const TTS_MODE_TEXT_TO_SPEECH = 'Text to Speech';

const Validations = buildValidations({
  blocks: [
    validator('blocks-not-empty', {
      message: 'operator.workflows.visual-builder.validations.blank-message-error',
      messageTranslated: true,
    }),
    validator('workflow-step-blocks-audio-snippets-have-no-meaningful-content', {
      message: 'operator.workflows.visual-builder.validations.audio-files-invalid',
      messageTranslated: true,
    }),
    validator('workflow-step-blocks-no-pending-audio-uploads', {
      message: 'operator.workflows.visual-builder.validations.audio-upload-pending',
      messageTranslated: true,
    }),
  ],
  inputMode: [
    validator('presence', {
      presence: true,
      messageKey: 'operator.workflows.visual-builder.validations.content-is-missing',
    }),
  ],
  ttsLanguage: [validator('presence', true)],
  ttsMode: [validator('presence', true)],
});

export default class PhoneConfig extends Fragment.extend(Validations) {
  @fragmentArray('common/blocks/block', { polymorphic: true, typeKey: 'modelKey' })
  declare blocks: SyncHasMany<Block>;
  @attr('string', { defaultValue: 'en-US' }) declare ttsLanguage: string;
  @attr('string', { defaultValue: TTS_MODE_TEXT_TO_SPEECH }) declare ttsMode: string;
  @attr('string', { defaultValue: '' }) declare inputMode: string;
  @attr('number', { defaultValue: 4 }) declare numDigits: number;
  @attr('string', { defaultValue: '' }) declare finishOnKey: string;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'operator/visual-builder/step/attribute-collector/phone-config': typeof PhoneConfig;
  }
}
